import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { debounce } from 'lodash';
const ExcelJS = require('exceljs');
import moment from 'moment';
import { Input, Button, Space, Modal, Badge, message, DatePicker } from 'antd';
import { DownloadOutlined, SwapOutlined } from '@ant-design/icons';
import { TableLayout, RangeDateFilter, BtnConfirm, UploadExcelButton } from '~components';
import ApiServices from '~services';
import Utils from '~commons/utils';
import { TableTitle, Wrapper } from '~commons/styles';
import { TicketIsAdded } from './ticket-is-added';
import { FormUpdate } from './form-update';
import { FormChangeDissolveDate } from './form-change-dissolvedate';
import { DATE_FORMAT, DATE_FORMAT_SEND_API } from '~commons/constants';

const EXCEL_TEMPLATE_URL = Utils.getAppUrl() + 'Files/Import_Excel/Giai_Tru_Bill.xlsx';

const DEFAULT_QUERIES = {
  PageSize: 10,
  PageNumber: 1,
  DateFrom: moment().startOf('month').format(),
  DateTo: moment().endOf('date').format(),
};

const UpdateTicketBill = () => {
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState('');
  const [billContList, setBillContList] = useState([]);
  const [filter, setFilter] = useState(DEFAULT_QUERIES);
  const [dataRowSelected, setDataRowSelected] = useState(null);
  const [isCreateTicketList, setCreateTicketList] = useState([]);
  const [currentTicketSelected, setCurrentTicketSelected] = useState(null);
  const [selectedMultipleTicket, setSelectedMultipleTicket] = useState([]);
  const [showChangeDissolveData, setShowChangeDissolveData] = useState(false);

  const [assignDateSearch, setAssignDateSearch] = useState(null);
  const [dissolveDateSearch, setDissolveDateSearch] = useState(null);

  const [loadingExport, setLoadingExport] = useState(false);

  const countSelectedTicket = useMemo(() => {
    return selectedMultipleTicket?.length;
  }, [selectedMultipleTicket]);

  const getData = async (query = DEFAULT_QUERIES) => {
    setLoading(true);
    const newQuery = {
      ...query,
      DateFrom: moment(query.DateFrom).format('YYYY-MM-DD'),
      DateTo: moment(query.DateTo).format('YYYY-MM-DD'),
    };

    return ApiServices.getBillContList(newQuery)
      .then((res) => {
        if (res?.data) {
          setBillContList(res?.data);
        }
      })
      .catch((err) => {
        console.error('get Bill cont Error', err);
      })
      .finally(() => setLoading(false));
  };

  const onColumnSearch = (event) => {
    setFilter((prev) => {
      const Columns = { ...prev.Columns };
      const value = event.target.value;
      const name = event.target.name;
      if (!value) {
        delete Columns[name];
        return { ...prev, Columns, PageNumber: 1 };
      }
      Columns[name] = value;
      return { ...prev, Columns, PageNumber: 1 };
    });
  };
  const onColumnSearchDate = (event, select = '') => {
    setFilter((prev) => {
      const Columns = { ...prev.Columns };
      const value = select ? event : event.target.value;
      const name = select ? select : event.target.name;
      if (!value) {
        delete Columns[name];
        return { ...prev, Columns, PageNumber: 1 };
      }
      Columns[name] = value;
      return { ...prev, Columns, PageNumber: 1 };
    });
  };
  const handleChangeAssignDateSearch = (date) => {
    setAssignDateSearch(date);
    const dataSearch = date ? moment(date).format(DATE_FORMAT_SEND_API) : null;
    onColumnSearchDate(dataSearch, 'assignDate');
  };
  const handleChangeDissolveDateSearch = (date) => {
    setDissolveDateSearch(date);
    const dataSearch = date ? moment(date).format(DATE_FORMAT_SEND_API) : null;
    onColumnSearchDate(dataSearch, 'dissolveDate');
  };

  const timeoutGetData = useCallback(
    debounce((newFilter) => {
      getData(newFilter);
    }, 500),
    []
  );
  useEffect(() => {
    timeoutGetData(filter);
  }, [filter]);

  const handleCancel = () => {
    setDataRowSelected(null);
    setCreateTicketList([]);
    setCurrentTicketSelected(null);
  };

  const handleCancelChangeDissolveDate = () => {
    setShowChangeDissolveData(false);
  };

  const handlePrintMultipleTicket = () => {
    setShowChangeDissolveData(true);
  };
  const reloadChangeDissolveDate = () => {
    setSelectedMultipleTicket([]);
    setShowChangeDissolveData(false);
    timeoutGetData(filter);
  };

  const reload = () => {
    return timeoutGetData(filter);
  };

  const onRowSelected = async (record) => {
    if (loading) return;

    setLoading(true);
    return ApiServices.getDetailTicket(record.id)
      .then((res) => {
        if (res?.data?.data) {
          const dataIsCreateTicket = res?.data?.data?.expenses?.filter((item) => {
            return item?.objTicketExpenses;
          });
          const differentTicket = dataIsCreateTicket?.filter(
            (item) => item?.objTicketExpenses?.ticketId !== record.id
          );
          const mapExpenses = differentTicket?.map((item) => {
            item.key = item.id;
            item.isExpenses = item?.objTicketExpenses ? true : false;
            item.price = item?.objTicketExpenses ? item?.objTicketExpenses?.price : '';
            item.vat = item?.objTicketExpenses ? item?.objTicketExpenses?.vat : '';
            item.total = item?.objTicketExpenses ? item?.objTicketExpenses?.total : '';
            item.billNumber = item?.objTicketExpenses ? item?.objTicketExpenses?.billNumber : '';
            item.billDate = item?.objTicketExpenses ? item?.objTicketExpenses?.billDate : null;
            item.supplierName = item?.objTicketExpenses
              ? item?.objTicketExpenses?.supplierName
              : '';

            return item;
          });
          const currentTicket = dataIsCreateTicket?.filter(
            (item) => item?.objTicketExpenses?.ticketId === record.id
          );
          setCreateTicketList(mapExpenses || []);
          setCurrentTicketSelected(currentTicket);
          setDataRowSelected(record);
        }
      })
      .catch((err) => {
        console.log({ err });
      })
      .finally(() => setLoading(false));
  };

  const handleDelete = (ticketId) => {
    if (loading) return;
    setLoading(true);
    ApiServices.deleteTicket(ticketId)
      .then((res) => {
        if (res.data) {
          reload();
        }
      })
      .catch((err) => {
        console.error('Delete failed: ', err);
        message.error('Xoá thất bại, Vui lòng thử lại sau!');
      })
      .finally(() => setLoading(false));
  };

  const columns = [
    {
      title: (
        <TableTitle>
          Số phiếu
          <Input name='aid' onChange={onColumnSearch} placeholder='Search' />
        </TableTitle>
      ),
      dataIndex: 'aid',
      align: 'center',
      width: 100,
      render: (value, record) => (
        <a onClick={() => onRowSelected(record)}>{value || 'underFine'}</a>
      ),
    },
    {
      title: (
        <TableTitle>
          Folder
          <Input name='folder' onChange={onColumnSearch} placeholder='Search' />
        </TableTitle>
      ),
      dataIndex: 'folder',
      align: 'center',
      width: 150,
    },
    {
      title: (
        <TableTitle>
          Số Cont
          <Input name='contNumber' onChange={onColumnSearch} placeholder='Search' />
        </TableTitle>
      ),
      dataIndex: 'contNumber',
      align: 'center',
      width: 150,
    },
    {
      title: (
        <TableTitle>
          Số SubNo
          <Input name='subnoNumber' onChange={onColumnSearch} placeholder='Search' />
        </TableTitle>
      ),
      dataIndex: 'subnoNumber',
      align: 'center',
      width: 200,
    },
    {
      title: (
        <TableTitle>
          Khách hàng
          <Input name='customerName' onChange={onColumnSearch} placeholder='Search' />
        </TableTitle>
      ),
      dataIndex: 'customerName',
      align: 'center',
      width: 200,
    },
    {
      title: (
        <TableTitle>
          Ngày đơn hàng
          <DatePicker
            value={assignDateSearch}
            onChange={handleChangeAssignDateSearch}
            placeholder='Search'
            style={{ width: '100%' }}
            format={DATE_FORMAT}
            allowClear={true}
          />
        </TableTitle>
      ),
      dataIndex: 'billReceivedDate',
      align: 'center',
      width: 130,
      render: (val) => Utils.formatDate(val),
    },
    {
      title: (
        <TableTitle>
          Ngày giải trừ
          <DatePicker
            value={dissolveDateSearch}
            onChange={handleChangeDissolveDateSearch}
            placeholder='Search'
            style={{ width: '100%' }}
            format={DATE_FORMAT}
            allowClear={true}
          />
        </TableTitle>
      ),
      dataIndex: 'dissolveDate',
      align: 'center',
      width: 130,
      render: (val) => Utils.formatDate(val),
    },
    {
      title: (
        <TableTitle>
          Số tiền
          <Input name='total' onChange={onColumnSearch} placeholder='Search' />
        </TableTitle>
      ),
      dataIndex: 'total',
      align: 'center',
      width: 150,
      render: (value) => Utils.formatNumber(value),
    },
    {
      title: (
        <TableTitle>
          Người giải trừ
          <Input name='createdBy' onChange={onColumnSearch} placeholder='Search' />
        </TableTitle>
      ),
      dataIndex: 'createdBy',
      align: 'center',
      width: 150,
    },
    {
      title: (
        <TableTitle>
          Ghi chú
          <Input name='note' onChange={onColumnSearch} placeholder='Search' />
        </TableTitle>
      ),
      dataIndex: 'note',
      align: 'center',
      width: 150,
    },
    {
      title: 'Action',
      fixed: 'right',
      width: 75,
      render: (record) => <BtnConfirm onConfirm={() => handleDelete(record?.id)}>Xóa</BtnConfirm>,
    },
  ];

  const pagination = {
    total: billContList?.totalRecords || 0,
    showSizeChanger: true,
    pageSize: filter.PageSize,
    current: filter.PageNumber,
    onChange: (PageNumber, PageSize) =>
      setFilter((prev) => ({
        ...prev,
        PageNumber,
        PageSize,
      })),
  };

  const onUploadExcel = (file) => {
    if (loading) return;
    setLoading(true);
    ApiServices.importExcelForBookingBillTicket(file)
      .then((res) => {
        if (res?.data?.data) {
          message.success(res?.data?.data);
          timeoutGetData(filter);
        }
      })
      .catch((err) => {
        console.error('UPLOAD IMPORT ERROR', err);
        message.error('Thao tác thất bại, Vui lòng thử lại sau!');
      })
      .finally(() => setLoading(false));
  };

  const handleExportExcel = async (dataExport = []) => {
    console.log({ dataExport });
    const workbook = new ExcelJS.Workbook();
    // Ten sheet
    const sheetSummary = workbook.addWorksheet('Giải trừ Bill', {
      properties: { tabColor: { argb: 'FF00FF00' } },
      views: [{ showGridLines: false }],
    });
    // sheetSummary.properties.defaultRowHeight = 18;
    sheetSummary.properties.defaultColWidth = 15;
    sheetSummary.getColumn(1).width = 5;
    sheetSummary.getRow(2).font = {
      name: 'Arial',
      family: 2,
      size: 16,
      bold: true,
    };
    sheetSummary.getRow(2).alignment = { vertical: 'middle', horizontal: 'center' };
    sheetSummary.getCell('E2').value = 'DANH SÁCH GIẢI TRỪ BILL';
    sheetSummary.getRow(3).alignment = { vertical: 'middle', horizontal: 'center' };
    const date = `Từ ${moment(filter?.DateFrom).format('DD/MM/YYYY')} Đến ${moment(
      filter?.DateTo
    ).format('DD/MM/YYYY')}`;
    sheetSummary.getCell('E3').value = date;
    // Add table
    const arrDetail = await dataExport?.map((item) => {
      const dataItem = [
        item?.aid, // sO pHIEU
        item?.folder || 0, // Folder
        item?.contNumber || '', // So Cont
        item?.subnoNumber || '', // Booking Bill
        item?.customerName || '', // Khach Hang
        item?.billReceivedDate && new Date(moment(item?.billReceivedDate).format('YYYY-MM-DD')), // Ngày Đơn Hàng
        item?.dissolveDate && new Date(moment(item?.dissolveDate).format('YYYY-MM-DD')), // Ngày Giải Trừ
        item?.total || 0, // Số Tiền
        item?.createdBy || '', // Người Giải Trừ
        item?.note || '', // Ghi Chu
      ];
      return dataItem;
    });

    await sheetSummary.addTable({
      name: 'TableSummary',
      ref: 'B5',
      headerRow: true,
      totalsRow: true,
      style: {
        theme: 'TableStyleMedium23', // 23
        // showRowStripes: true,
      },
      columns: [
        { name: 'Số Phiếu', totalsRowLabel: '', filterButton: false },
        { name: 'Folder', totalsRowLabel: '', filterButton: false },
        {
          name: 'Số Cont',
          filterButton: false,
        },
        { name: 'Số SubNo', totalsRowLabel: '', filterButton: false },
        {
          name: 'Khách Hàng',
          filterButton: false,
        },
        {
          name: 'Ngày Đơn Hàng',
          filterButton: false,
        },
        {
          name: 'Ngày Giải Trừ',
          filterButton: false,
        },
        {
          name: 'Số Tiền',
          filterButton: false,
          totalsRowFunction: 'sum',
        },
        {
          name: 'Người Giải Trừ',
          filterButton: false,
        },
        {
          name: 'Ghi Chú',
          filterButton: false,
        },
      ],
      rows: arrDetail,
    });
    // ========== STYLES =====================
    sheetSummary.getRow(5).alignment = { vertical: 'middle', horizontal: 'center' };
    sheetSummary.getColumn(9).numFmt = '#,##0';
    sheetSummary.getColumn(6).alignment = { wrapText: true };
    sheetSummary.getColumn(11).alignment = { wrapText: true };
    sheetSummary.getColumn(2).width = 10;
    sheetSummary.getColumn(3).width = 10;
    sheetSummary.getColumn(5).width = 30;
    sheetSummary.getColumn(6).width = 25;
    sheetSummary.getColumn(9).width = 15;
    sheetSummary.getColumn(10).width = 20;
    sheetSummary.getColumn(11).width = 30;

    try {
      await workbook.xlsx.writeBuffer().then(function (data) {
        const blob = new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = `Danh_Sach_Giai_Tru_Bill_${date}_Xuat_Excel_Luc_${moment().format(
          'DD-MM-YY HH:mm'
        )}.xlsx`; // name excel
        // anchor.download = `${moment().format('HH:mm')}.xlsx`;
        anchor.click();
        window.URL.revokeObjectURL(url);
      });
    } catch (error) {
      console.log({ error });
    } finally {
      setLoading(false);
    }
  };

  const handleGetDataExport = async (query = DEFAULT_QUERIES) => {
    if (!query?.DateFrom || !query?.DateTo || loadingExport) return;

    const dateFrom = moment(query?.DateFrom).format('YYYY-MM-DD');
    const dateTo = moment(query?.DateTo).format('YYYY-MM-DD');

    setLoadingExport(true);
    return ApiServices.getDataExportTicketBillCont(dateFrom, dateTo)
      .then((res) => {
        if (res?.data?.data) {
          return handleExportExcel(res?.data?.data || []);
        }
      })
      .catch((err) => {
        console.error('get Data Export Report Accountants Bills Error: ', err);
      })
      .finally(() => {
        setLoadingExport(false);
      });
  };

  const rowSelection = (selectedRowKeys) => {
    setSelectedMultipleTicket(selectedRowKeys);
  };

  return (
    <Wrapper>
      <h3>Danh sách giải trừ Bill</h3>
      <Space style={{ marginBottom: '10px' }}>
        <RangeDateFilter query={filter} onChange={setFilter} />
        <UploadExcelButton
          loading={loading}
          onChange={onUploadExcel}
          templateUrl={EXCEL_TEMPLATE_URL}
          importLabel='Import Excel'
        />
        <Button
          type='primary'
          icon={<DownloadOutlined />}
          style={{ padding: '0px 20px', marginLeft: '10px' }}
          disabled={!billContList?.data?.length}
          onClick={() => handleGetDataExport(filter)}
        >
          Export Excel
        </Button>
        <Badge count={countSelectedTicket}>
          <Button
            danger
            icon={<SwapOutlined />}
            style={{ padding: '0px 20px', marginLeft: '10px' }}
            disabled={countSelectedTicket < 1}
            onClick={handlePrintMultipleTicket}
          >
            Đổi ngày giải trừ
          </Button>
        </Badge>
      </Space>
      <TableLayout
        rowKey='id'
        columns={columns}
        data={billContList?.data || []}
        loading={loading}
        selectParent={selectedMultipleTicket}
        onSelectChange={rowSelection}
        selected={selected}
        closeDrawer={() => setSelected(null)}
        pagination={pagination}
      />
      <Modal
        title='Thông tin chi tiết:'
        open={!!dataRowSelected}
        onCancel={handleCancel}
        footer={null}
        style={{
          top: 20,
        }}
        width='80%'
      >
        <TicketIsAdded dataExpenses={isCreateTicketList} />
        <FormUpdate
          dataCurrent={currentTicketSelected}
          dataInfo={dataRowSelected}
          handleCancel={handleCancel}
          reload={reload}
        />
      </Modal>
      <Modal
        title='Đổi ngày giải trừ:'
        open={showChangeDissolveData}
        onCancel={handleCancelChangeDissolveDate}
        footer={null}
        style={{
          top: 20,
        }}
      >
        <FormChangeDissolveDate
          selectedMultipleTicket={selectedMultipleTicket}
          reloadChangeDissolveDate={reloadChangeDissolveDate}
        />
      </Modal>
    </Wrapper>
  );
};

export { UpdateTicketBill };
